import * as React from 'react'

import { styled } from '~/styled'

import { EmptyStateProvider } from './EmptyState.context'
import { EmptyStateBody } from './EmptyStateBody'
import { EmptyStateImage } from './EmptyStateImage'
import { EmptyStateTitle } from './EmptyStateTitle'

const EmptyStateContainer = styled(
  'div',
  {
    base: ['flex', 'flex-col', 'items-center', 'text-center', '*:last:mb-0'],
    variants: {
      size: {
        xs: ['p-2'],
        sm: ['p-3'],
        md: ['p-4'],
        lg: ['p-8'],
        xl: ['p-10']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

export type EmptyStateProps = React.ComponentProps<typeof EmptyStateContainer>

const EmptyStateComponent = ({ size = 'sm', ...rest }: EmptyStateProps) => (
  <EmptyStateProvider size={size}>
    <EmptyStateContainer size={size} {...rest} />
  </EmptyStateProvider>
)

export const EmptyState = Object.assign(EmptyStateComponent, {
  Image: EmptyStateImage,
  Title: EmptyStateTitle,
  Body: EmptyStateBody
})

EmptyStateComponent.displayName = 'EmptyState'
